module.exports = __webpack_public_path__ + "static/media/medial-flexion-up-1.9c48b380.png";